import { render } from "./MainHeader.vue?vue&type=template&id=7b18718f"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import "./MainHeader.vue?vue&type=style&index=0&id=7b18718f&lang=sass"

import exportComponent from "/home/runner/work/robocleaner/robocleaner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__